var _circle, _g, _circle2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVerifyAwaiting = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 23,
    r: 19,
    fill: "#FFC633"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_5700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4 16.3333H12.6C11.7176 16.3333 11 17.0808 11 17.9999V27.9999C11 28.9191 11.7176 29.6666 12.6 29.6666H25.4C26.2824 29.6666 27 28.9191 27 27.9999V17.9999C27 17.0808 26.2824 16.3333 25.4 16.3333ZM16.372 19.6666C17.2928 19.6666 17.972 20.3741 17.972 21.3333C17.972 22.2924 17.2928 22.9999 16.372 22.9999C15.4512 22.9999 14.772 22.2924 14.772 21.3333C14.772 20.3741 15.4504 19.6666 16.372 19.6666ZM19.344 26.3333H13.4V25.9458C13.4 24.8016 14.7408 23.6249 16.372 23.6249C18.0032 23.6249 19.344 24.8016 19.344 25.9458V26.3333ZM24.6 25.4999H21.4V23.8333H24.6V25.4999ZM24.6 22.1666H20.6V20.4999H24.6V22.1666Z",
    fill: "white"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 9,
    r: 8,
    fill: "#FFC633",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 11V13H34V11H32Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 5V10H34V5H32Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_5700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(11 15)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVerifyAwaiting);
export default ForwardRef;